import { render, staticRenderFns } from "./Dept.vue?vue&type=template&id=3b8f10d6&scoped=true&"
import script from "./Dept.vue?vue&type=script&lang=js&"
export * from "./Dept.vue?vue&type=script&lang=js&"
import style0 from "./Dept.vue?vue&type=style&index=0&id=3b8f10d6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8f10d6",
  null
  
)

export default component.exports